/* eslint-disable global-require */
import Logout from './logout';

// The top-level (parent) route
const routes = {
  path: '',

  // Keep in mind, routes are evaluated in order
  children: [
    {
      path: '',
      load: () => import(/* webpackChunkName: 'homev2' */ './home'),
    },
    {
      path: '/logout',
      action: Logout,
    },
    {
      path: '/new-password',
      load: () => import(/* webpackChunkName: 'newPassword' */ './newPassword'),
    },
    {
      path: '/sign-in',
      load: () => import(/* webpackChunkName: 'signIn' */ './signIn'),
    },
    {
      path: '/track-mail',
      load: () => import(/* webpackChunkName: 'track-mail' */ './trackMailer'),
    },
    // {
    //   path: '/demo',
    //   load: () => import(/* webpackChunkName: 'demo' */ './demo'),
    // },
    // {
    //   path: '/org-selection',
    //   load: () =>
    //     import(/* webpackChunkName: 'org-selection' */ './orgSelection'),
    // },
    {
      path: '/change-password',
      load: () =>
        import(/* webpackChunkName: 'changePassword' */ './changePassword'),
    },
    {
      path: '/legal/cookie-policy',
      load: () =>
        import(/* webpackChunkName: 'cookiePolicy' */ './legal/cookiePolicy/'),
    },
    {
      path: '/legal/gdpr-policy',
      load: () => import(/* webpackChunkName: 'cookiePolicy' */ './legal/gdpr'),
    },
    // {
    //   path: '/legal/pdpa-policy',
    //   load: () => import(/* webpackChunkName: 'cookiePolicy' */ './legal/pdpa'),
    // },
    // Wildcard routes, e.g. { path: '(.*)', ... } (must go last)
    {
      path: '(.*)',
      load: () => import(/* webpackChunkName: 'not-found' */ './not-found'),
    },
  ],

  async action({ query, next, userToken }) {
    // Execute each child route until one of them return the result
    const route = await next();

    // Provide default values for title, description etc.
    route.title = `${route.title || 'Untitled Page'}`;
    route.description = route.description || '';

    return route;
  },
};

// The error page is available by permanent url for development mode
if (__DEV__) {
  routes.children.unshift({
    path: '/error',
    action: require('./error').default,
  });
}

export default routes;



// WEBPACK FOOTER //
// ./src/routes/index.js